import { render, staticRenderFns } from "./cpLabel.vue?vue&type=template&id=9864430a&scoped=true&"
import script from "./cpLabel.vue?vue&type=script&lang=js&"
export * from "./cpLabel.vue?vue&type=script&lang=js&"
import style0 from "./cpLabel.vue?vue&type=style&index=0&id=9864430a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9864430a",
  null
  
)

export default component.exports